import React, { useState } from "react";
import { useFormikContext } from "formik";
import { FiUpload } from "react-icons/fi";
import "./LegalDocumentUpload.css";
import ErrorPopup from "../../components/common/ErrorPopup";

const UploadField = ({ label, name, disabled }) => {
  const { setFieldValue, values, errors, touched, setFieldError, setFieldTouched } = useFormikContext();
  const inputRef = React.useRef(null);
  const [errorPopup, setErrorPopup] = React.useState(null);

  const handleFileChange = (event) => {
    if (disabled) return;
    const file = event.currentTarget.files[0];
    if (file) {
      const allowedTypes = ["image/jpeg", "image/jpg", "application/pdf", "image/png"];
      if (!allowedTypes.includes(file.type)) {
        setErrorPopup("Unsupported file format. Only JPEG, PNG, and PDF are allowed.");
        setFieldError(name, "Unsupported file format.");
        event.target.value = null;
        setFieldValue(name, null);
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setErrorPopup("Each file must be less than 5MB.");
        setFieldError(name, "File size exceeds 5MB limit.");
        event.target.value = null; // Clear the input
        setFieldValue(name, null); // Clear from formik
        return;
      }
      setFieldValue(name, file);
      setFieldTouched(name, true);
      setFieldError(name, undefined); // Clear any previous error
    }
  };

  const handleBoxClick = (event) => {
    if (disabled) return;
    // If user clicked inside the box but not on the remove button
    if (!event.target.closest(".remove-button")) {
      inputRef.current.click(); // manually open file dialog
    }
  };

  const handleRemoveFile = (e) => {
    if (disabled) return;
    e.stopPropagation(); // prevent triggering file dialog
    setFieldValue(name, null);
  };

  return (
    <div className={`upload-container ${disabled ? "disabled-upload" : ""}`}>
      <div className='upload-label'>{label}</div>

      <div
        className={`upload-box ${disabled ? "disabled-box" : "clickable-box"}`}
        onClick={handleBoxClick}
      >
        {values[name] ? (
          <div className='file-preview'>
            <div className='upload-file-name'>{values[name].name}</div>
            {values[name].url && (
              <a
                href={values[name].url}
                target='_blank'
                rel='noopener noreferrer'
                className='view-link'
                onClick={(e) => e.stopPropagation()}
              >
                (View)
              </a>
            )}
            <div className='upload-supported-text'>Supported formats: jpeg, pdf (Max 5MB)</div>
            {!disabled && (
              <button
                className='remove-button'
                type='button'
                onClick={handleRemoveFile}
              >
                Remove
              </button>
            )}
          </div>
        ) : (
          <div className='upload-drop-area'>
            <FiUpload className='upload-icon' />
            <div className='upload-text'>
              {disabled ? (
                "No file uploaded"
              ) : (
                <>
                  Drag & Drop or <span className='choose-file'>choose file</span>{" "}
                  to upload
                </>
              )}
            </div>
            {!disabled && (
              <div className='upload-supported-text'>
                Supported formats: jpeg, pdf (Max 5MB)
              </div>
            )}
          </div>
        )}
      </div>
      {errors[name] && (
        <div className='upload-error-message'>{errors[name]}</div>
      )}

      <input
        type='file'
        id={name}
        name={name}
        className='upload-input'
        accept='.jpeg,.jpg,.pdf'
        onChange={handleFileChange}
        ref={inputRef}
        style={{ display: "none" }}
        disabled={disabled}
      />
      {errorPopup && (
        <ErrorPopup message={errorPopup} onClose={() => setErrorPopup(null)} />
      )}
    </div>
  );
};

export default UploadField;
